module.exports = __webpack_public_path__ + "img/sec5_1_3.59bb11be.jpg";